<i18n>
{
  "en": {
    "createLinkTreeTitle": "Creating link tree",
    "editLinkTreeTitle": "Editing link tree",
    "name": "Name",
    "emptyFieldError": "Required field",
    "menus": "Menus"
  },
  "es": {
    "createLinkTreeTitle": "Creando un arbol de links",
    "editLinkTreeTitle": "Editanto un arbol de links",
    "name": "Nombre",
    "emptyFieldError": "Campo obligatorio",
    "menus": "Menus"
  }
}
</i18n>
<template>
  <v-dialog v-model="visible" max-width="600px" scrollable persistent>
    <v-card v-if="visible" scrollable persistent class="px-7 py-4">
      <v-card-title class="pa-0 mb-2">
        {{ modalTitle }}
      </v-card-title>
      <v-sheet style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <v-text-field :disabled="type === 'edit'" v-model="name" :rules="nameRules" :label="$t('name')" class="required"/>
          <v-select v-model="menus" :rules="listRules" :items="menuList" :menu-props="{ maxHeight: '400' }" :label="$t('menus')"
          item-value="guid" item-text="title" class="required" chips multiple/>
          <dynameat-modal-buttons class="mt-3" @cancel="onCancel" @confirm="onConfirm" :confirmDisabled="!valid"/>
        </v-form>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>
<script>
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import { notEmptyList, notEmptyString } from '@core/helpers/formValidators';
import { LinkTree } from '../models';

@Component
@Components({
  DynameatModalButtons
})
@MapGetters(['selectedPointOfSale', 'menuList'])
export default class LinkTreeCreateEditModal extends Vue {
  @Prop({
    Object,
    validator(linkTree) {
      return linkTree instanceof LinkTree;
    }
  }) linkTree;

  @Prop({
    String,
    default: 'create',
    validator(type) {
      return type === 'create' || type === 'edit';
    }
  }) type;

  @Prop({ Boolean, default: false }) visible;

  menus = []

  valid = false;

  name = ''

  clearOwnData() {
    this.menus = [];
    this.valid = false;
  }

  onCancel() {
    this.clearOwnData();
    this.$emit('cancel');
  }

  onConfirm() {
    if (this.$refs.form.validate()) {
      const linkTreeToHandle = new LinkTree(this.linkTree?.guid || null, this.selectedPointOfSale.guid, this.menus, this.name);
      this.$emit('confirm', linkTreeToHandle);
    }
  }

  get modalTitle() {
    return this.$t(`${this.type}LinkTreeTitle`);
  }

  get nameRules() {
    return [notEmptyString(this.$t('emptyFieldError'))];
  }

  get listRules() {
    return [notEmptyList(this.$t('emptyFieldError'))];
  }

  @Watch('linkTree', { inmediate: true })
  onLinkTreeChanged(newLinkTree) {
    if (newLinkTree) {
      this.clearOwnData();
      this.name = newLinkTree.name;
      this.menus = newLinkTree.menus;
    }
  }
}
</script>
